import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { BONO1_URL, BONO2_URL, BONO3_URL, BONO4_URL, BONO5_URL, BONO6_URL } from './constants';
const bonos = [{
  n: 'Bono 1',
  title: 'Mapa de Implementación 7 Días',
  desc: 'Empieza a recuperar tus domingos desde la primera semana con un plan claro, simple y fácil de seguir.',
  result: 'Resultados desde el día 1 · Sin abrumarte.',
  price: '$25 USD',
  img: BONO1_URL
}, {
  n: 'Bono 2',
  title: 'Selector Inteligente de Recursos',
  desc: 'Encuentra el recurso ideal para cualquier clase en segundos y deja de perder tiempo buscando materiales.',
  result: 'Clase funcionando en 5 minutos · Sin preparación.',
  price: '$20 USD',
  img: BONO2_URL
}, {
  n: 'Bono 3',
  title: 'Kit de Adaptación Curricular IA',
  desc: 'Adapta sesiones, actividades y materiales para diferentes necesidades sin empezar desde cero.',
  result: '2 semanas listas antes del primer lunes.',
  price: '$22 USD',
  img: BONO3_URL
}, {
  n: 'Bono 4',
  title: 'El Cuaderno del Maestro Organizado',
  desc: 'Organiza tus pendientes, recursos y planificación para trabajar con menos estrés y mucho más orden.',
  result: 'Palabras exactas · Para cada situación difícil.',
  price: '$15 USD',
  img: BONO4_URL
}, {
  n: 'Bono 5',
  title: 'Guía de Familias Aliadas',
  desc: 'Comunícate con las familias con más confianza, evita conflictos y deja de responder mensajes durante tus domingos.',
  result: 'Responde en 3 minutos · 0 mensajes el domingo.',
  price: '$18 USD',
  img: BONO5_URL
}, {
  n: 'Bono 6',
  title: 'Plan Anti-Atraso Escolar',
  desc: 'Recupera el control de tu planificación cuando te atrases y vuelve al ritmo sin sentirte abrumada.',
  result: 'Recupera una semana perdida en 15 minutos.',
  price: '$20 USD',
  img: BONO6_URL
}];
export function Bonos() {
  return <section className="bg-cream px-4 py-16" data-id="element-17" data-mp="26sscx2d1wkzw">
      <div className="mx-auto max-w-4xl text-center" data-id="element-18" data-mp="ys1w9efjr3av">
        <span className="inline-flex items-center gap-2 rounded-full bg-brandpurple/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-brandpurple" data-id="element-19" data-mp="12slqa94tpqss">
          <GiftIcon className="h-4 w-4" data-id="element-20" data-mp="osay92rs2661" /> 6 Bonos estratégicos
        </span>
        <h2 className="mx-auto mt-4 max-w-3xl font-display text-2xl font-black leading-tight text-navy sm:text-3xl" data-id="element-21" data-mp="tqunbc1o3y2m">
          🎁 Además del Método Domingo Libre, hoy recibirás GRATIS estas 6
          herramientas para ahorrar todavía más tiempo.
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-22" data-mp="62l6kojba0ic">
        {bonos.map((b, i) => <motion.div key={b.n} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.06
      }} className="flex items-center gap-4 rounded-2xl border border-navy/10 bg-white p-4 shadow-card" data-id="element-23" data-mp="b0wh71hfkf1m" data-mpi={i}>
            <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-24" data-mp="3nmlc9psjvdw1">
              <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-25" data-mp="3io0cfrh7mw84" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-26" data-mp="3sjbr69smc3fv">
              <div className="text-[11px] font-bold uppercase tracking-wide text-brandpurple" data-id="element-27" data-mp="3siaclvce8yte">
                🎁 {b.n}
              </div>
              <h3 className="font-display text-[15px] font-black leading-tight text-navy" data-id="element-28" data-mp="582cbdqoc9wm">
                {b.title}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-navy/60" data-id="element-29" data-mp="k4jmi1n4nihl">
                {b.desc}
              </p>
              <p className="mt-1.5 text-xs font-bold leading-relaxed text-brandpurple" data-id="element-30" data-mp="f3drfx5zvj4w">
                {b.result}
              </p>
              <div className="mt-2 flex flex-wrap items-center gap-2" data-id="element-31" data-mp="2dmije9ig9c5s">
                <span className="text-xs font-semibold text-navy/55" data-id="element-32" data-mp="2idqvxef2tdn6">
                  Valor: {b.price}
                </span>
                <span className="rounded-full bg-teal/15 px-2 py-0.5 text-[11px] font-bold uppercase text-teal" data-id="element-33" data-mp="2nddbvvmah7zo">
                  Gratis hoy
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-md rounded-2xl bg-navy p-6 text-center text-white shadow-soft" data-id="element-34" data-mp="1uoeoaizeddmz">
        <p className="text-xs font-bold uppercase tracking-widest text-white/60" data-id="element-35" data-mp="1zpc5as8o81mw">
          Valor total de bonos
        </p>
        <p className="mt-1 font-display text-4xl font-black" data-id="element-36" data-mp="3b2ejjgnasf3w">$120 USD</p>
        <p className="mt-2 text-sm font-semibold text-teal" data-id="element-37" data-mp="3b4ip030uhm6a">
          → GRATIS con tu Método Domingo Libre
        </p>
      </div>
    </section>;
}